<template>
  <div>
    <CCard>
      <CCardHeader>
        <CRow>
          <CCol class="align-self-center">
            <label class="mb-0 font-lg font-weight-bold">User</label>
          </CCol>
          <CCol class="text-right">
            <CButton @click="changeState" color="success" v-if="defaultState">
              <CIcon class="mr-2" height="36" name="cil-library-add"/>
              NEW USER
            </CButton>
          </CCol>
        </CRow>
      </CCardHeader>
      <CCardBody class="pt-0">
        <CCollapse :show="defaultState">
          <users
              :fields="fields"
              :items="users"
              @users="userActions"
          />
        </CCollapse>
        <add-user
            :form="form"
            @cancel="cancel('add')"
            @confirm="confirm"
            v-if="!defaultState"/>
      </CCardBody>
    </CCard>

    <CModal
        :centered="true"
        :show.sync="resetPasswordModal"
        color="success"
        title="Reset password"
    >
      <label class="mb-0">Name:</label><br/>
      <span
          class="font-weight-bold font-xl mt-1">{{ userResetInformation.firstName }} {{
          userResetInformation.lastName
        }}</span><br/>
      <CInput class="mt-1" label="New password:" placeholder="password" type="password" v-model="newPassword"/>
      <template #footer-wrapper>
        <CRow class="p-3 pt-0">
          <CCol class="text-right">
            <CButton @click="cancel('change')" class="mr-2" color="danger">Cancel</CButton>
            <CButton @click="resetUserPassword" color="success">Confirm</CButton>
          </CCol>
        </CRow>
      </template>
    </CModal>
  </div>
</template>

<script>
import {mapGetters} from "vuex"
import Users from "@/components/user/users";
import AddUser from "@/components/user/addUser";

export default {
  name: "MainTeacher",
  components: {AddUser, Users},
  data() {
    return {
      defaultState: true,
      tempId: "",
      fields: [
        {key: "no", label: "No.", _style: "width: 5%"},
        {key: "firstName", label: "Firstname", _style: "width:14%"},
        {key: "lastName", label: "Lastname", _style: "width:14%"},
        {key: "email", label: "Email", _style: "width:15%"},
        {key: "username", label: "Username", _style: "width:5%"},
        {key: "tel", label: "Telephone", _style: "width:6.5%"},
        {key: "role", label: "Role", _style: "width:3%"},
        {key: "activeStatus", label: "Status", _style: "width:5%"},
        {key: "teacherOptions", label: "#", _style: "width:15%"}
      ],
      resetPasswordModal: false,
      userResetInformation: {},
      newPassword: "",

      form: {
        firstName: "",
        lastName: "",
        username: "",
        email: "",
        password: "",
        tel: "",
        id: ""
      }
    }
  },
  mounted() {
    this.$store.dispatch("user/onSetUsers")
  },
  computed: {
    ...mapGetters({
      users: "user/getUsers",
      actionStatus: "action/actionStatus"
    })
  },
  watch: {
    users(value) {
      this.defaultState = true
    },
    actionStatus(value) {
      if (value) {
        this.deleteUser()
      }
    },
    resetPasswordModal(value) {
      if (!value) {
        this.newPassword = ""
      }
    }
  },
  methods: {
    setEmptyForm() {
      this.form = {
        firstName: "",
        lastName: "",
        username: "",
        email: "",
        password: "",
        tel: "",
        id: ""
      }
    },
    userActions(value) {
      this.tempId = value.items._id
      if (value.action === "edit") {
        this.form = {
          firstName: value.items.firstName,
          lastName: value.items.lastName,
          username: value.items.username,
          email: value.items.email,
          password: "xxxxxxxx",
          tel: value.items.tel,
          id: value.items.id
        }
        this.defaultState = false
      } else if (value.action === "delete") {
        let body = {
          title: "Notification",
          color: "warning",
          status: true,
          text: "Do you really want to delete the user?"
        }
        this.$store.commit("modal/onSetConfirmActionModalStatus", body)
      } else if (value.action === "change") {
        this.resetPasswordModal = true
        this.userResetInformation = value.items
      } else if (value.action === "changeStatus") {
        let userId = value.items.id
        let activeStatus = !value.items.activeStatus
        this.$store.dispatch("user/onEditUsers", {userId, body: {activeStatus: activeStatus}})
      }
    },
    deleteUser() {
      this.$store.dispatch("user/onDeleteUser", this.tempId)
    },
    cancel(type) {
      if (type === "change") {
        this.resetPasswordModal = false
        this.tempId = ""
        this.userResetInformation = ""
      } else if (type === "add") {
        this.setEmptyForm()
        this.defaultState = true
      }
    },
    resetUserPassword() {
      let body = {
        newPassword: this.newPassword,
        userId: this.userResetInformation._id
      }
      this.$store.dispatch("user/onResetUserPassword", body)
      this.resetPasswordModal = false
    },
    changeState() {
      this.defaultState = !this.defaultState
    },
    confirm(value) {
      if (value.id === '') {
        this.$store.dispatch("user/onCreateUsers", value)
      } else {
        delete value.password
        let userId = value.id
        let body = value
        delete body.id
        this.$store.dispatch("user/onEditUsers", {userId, body})
      }
    }
  }
}
</script>
